export const DAILY_RECOMMENDATION_MENU_NAME = 'Daily Recommendations';

export function getTodayDayNumber(date: Date = new Date()): number {
  return date.getDate();
}
